import { AxiosInstance } from "axios";
import ApiClient from "src/utils/ApiClient";

let cashedInstance: AxiosInstance | null = null;

const createPermissionsApiClient = () => {
  cashedInstance = new ApiClient({
    baseURL: (window as any).permissionsUrl,
    headers: {},
  }).client;

  cashedInstance.interceptors.response.use((response) => response);

  return cashedInstance;
};

const PermissionsApiClient = {
  get instance() {
    return cashedInstance || createPermissionsApiClient();
  },

  reset() {
    cashedInstance = null;
  },
};

export { PermissionsApiClient };
